import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["hiddenField"];

  updateHiddenField(event) {
    this.hiddenFieldTarget.value = event.target.value;
  }
}
